import React from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";

import Button from "@mui/material/Button";
import SvgIcon from "@mui/material/SvgIcon";

import COLOR_THEMES from "../../../../colorThemes";
import {Look3DIcon} from "../../../common/icons";
import {FormattedMessage} from "react-intl";
import {featureInterface} from "../../../../interfaces/featureInterface";
import WithShopFeatureVisualizeClick from "./withShopFeatureVisualizeClick";


const ShopFeatureVisualizeButton = (props) => {

  const {activeTheme, feature} = props;

  if (!feature || !feature.dbFeature || !feature.dbFeature.s3Bindings) {
    return null
  }

  return (
    <WithShopFeatureVisualizeClick feature={feature}>
      {(visualizeButtonClick) => (
        <Button className={"look-button look-button--gray look-button--42 look-button--10-radius look-button--no-transform"}
                startIcon={(
                  <SvgIcon>
                    <Look3DIcon color={COLOR_THEMES[activeTheme].primary} />
                  </SvgIcon>
                )}
                onClick={visualizeButtonClick}>
          <FormattedMessage id="shop.feature.visualize.button"/>
        </Button>
      )}
    </WithShopFeatureVisualizeClick>
  )
};

ShopFeatureVisualizeButton.propTypes = {
  feature: PropTypes.shape(featureInterface).isRequired
}

const mapStateToProps = (store) => {
  const {activeTheme} = store.serverState;
  const {activePreset, bvPresets} = store.bathroomVisualizerState;

  return {
    activeTheme,
    activePreset,
    bvPresets,
  };
};

export default connect(mapStateToProps)(ShopFeatureVisualizeButton)
